import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

const selectSelf = (state: RootState) => state;
const getState = createSelector(selectSelf, (state) => state.defaultProjectUpdate);

const getProcessing = createSelector(
  getState,
  (state) => state.processing,
);

export const defaultProjectUpdateQuery = {
  getProcessing,
};
